import React from 'react';
import Link from '../../Link';
import SectionHeader from '../SectionHeader';

function SectionLinkedHeader(props) {
    const {href, ...otherProps} = props;

    return (
        <Link href={href}>
            <SectionHeader {...otherProps} />
        </Link>
    );
}

export default SectionLinkedHeader;
